import { render, staticRenderFns } from "./Nixpkgs.vue?vue&type=template&id=417ab1e4&"
import script from "./Nixpkgs.vue?vue&type=script&lang=js&"
export * from "./Nixpkgs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('417ab1e4')) {
      api.createRecord('417ab1e4', component.options)
    } else {
      api.reload('417ab1e4', component.options)
    }
    module.hot.accept("./Nixpkgs.vue?vue&type=template&id=417ab1e4&", function () {
      api.rerender('417ab1e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/repositories/Nixpkgs.vue"
export default component.exports